import { useEffect } from "react";
import { getIsMobile, defaultGameFilter } from "@nxplatform/helpers/helpers-pure";
import { clearLastPlayedGamesList } from "@nxplatform/casino/casino-category.slice";
const useCasinoGetRecentlyGamesHook = ({
  auth,
  categoryRecentlyPlayedEnabled,
  getGamesCasinoLastPlayed
}) => {
  const isMobile = getIsMobile();
  useEffect(() => {
    if (categoryRecentlyPlayedEnabled) {
      if (auth) {
        getGamesCasinoLastPlayed(defaultGameFilter());
      }
      if (!auth) {
        clearLastPlayedGamesList();
      }
    }
  }, [isMobile, auth, categoryRecentlyPlayedEnabled]);
};
export {
  useCasinoGetRecentlyGamesHook
};
